class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector('button.header__icon--search');
    this.drawer = this.querySelector('.phi--search-drawer');
    this.drawerInner = this.querySelector('.phi--search-drawer__inner');
    this.closeButton = this.querySelector('.phi--search-drawer__close');
    this.overlay = this.querySelector('.phi--search-drawer__overlay');
    this.searchInput = this.querySelector('input[type="search"]');

    this.onKeydownHandler = this.onKeydown.bind(this);
    
    if (this.openButton) {
      this.openButton.addEventListener('click', this.open.bind(this));
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.drawer.classList.contains('active')) {
      this.close();
    }
  }

  open(event) {
    if (event) {
      event.preventDefault();
    }
    
    this.drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.onKeydownHandler);
    
    // Show default content when opening (if search is empty)
    const defaultContent = this.querySelector('.phi--search-drawer__default-content');
    if (defaultContent) {
      defaultContent.style.display = 'block';
    }
    
    // Focus search input after animation
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.focus();
      }
    }, 300);
  }

  close() {
    this.drawer.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.onKeydownHandler);
    
    // Clear search input and show default content
    if (this.searchInput) {
      this.searchInput.value = '';
      // Trigger reset if using predictive search
      const resetButton = this.querySelector('button[type="reset"]');
      if (resetButton) {
        resetButton.click();
      }
    }
    
    // Show default content
    const defaultContent = this.querySelector('.phi--search-drawer__default-content');
    if (defaultContent) {
      defaultContent.style.display = 'block';
    }
  }
}

customElements.define('search-drawer', SearchDrawer);

